{
    "v": "5.8.1",
    "fr": 30,
    "ip": 0,
    "op": 60,
    "w": 500,
    "h": 500,
    "nm": "33 Menu",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 3,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Menu",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [-649.975, 50, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [733.32, 178.814],
                                                    [733.32, 33.309],
                                                    [878.825, 33.309],
                                                    [878.825, 178.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [732.49, 71.814],
                                                    [731.835, 16.309],
                                                    [877.34, 16.309],
                                                    [877.996, 71.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [520.859, 73.629],
                                                    [520.204, 18.124],
                                                    [877.709, 17.309],
                                                    [878.364, 72.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [520.859, 73.629],
                                                    [520.204, 18.124],
                                                    [877.709, 17.309],
                                                    [878.364, 72.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [732.49, 71.814],
                                                    [731.835, 16.309],
                                                    [877.34, 16.309],
                                                    [877.996, 71.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 58,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [733.32, 178.814],
                                                    [733.32, 33.309],
                                                    [878.825, 33.309],
                                                    [878.825, 178.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, 178.814],
                                                    [521.125, 33.309],
                                                    [666.63, 33.309],
                                                    [666.63, 178.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, 178.814],
                                                    [520.081, 123.309],
                                                    [665.586, 123.309],
                                                    [666.63, 178.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, 178.814],
                                                    [520.081, 123.309],
                                                    [877.586, 124.124],
                                                    [878.63, 179.629]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, 178.814],
                                                    [520.081, 123.309],
                                                    [877.586, 124.124],
                                                    [878.63, 179.629]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, 178.814],
                                                    [520.081, 123.309],
                                                    [665.586, 123.309],
                                                    [666.63, 178.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 58,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, 178.814],
                                                    [521.125, 33.309],
                                                    [666.63, 33.309],
                                                    [666.63, 178.814]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [733.32, -33.38],
                                                    [733.32, -178.886],
                                                    [878.825, -178.886],
                                                    [878.825, -33.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [732.306, -27.38],
                                                    [732.112, -80.886],
                                                    [877.617, -80.886],
                                                    [877.811, -27.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [522.938, -25.761],
                                                    [522.743, -79.266],
                                                    [878.248, -79.886],
                                                    [878.443, -26.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [522.938, -25.761],
                                                    [522.743, -79.266],
                                                    [878.248, -79.886],
                                                    [878.443, -26.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [732.306, -27.38],
                                                    [732.112, -80.886],
                                                    [877.617, -80.886],
                                                    [877.811, -27.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 58,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [733.32, -33.38],
                                                    [733.32, -178.886],
                                                    [878.825, -178.886],
                                                    [878.825, -33.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, -33.38],
                                                    [521.125, -178.886],
                                                    [666.63, -178.886],
                                                    [666.63, -33.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [520.275, -133.38],
                                                    [521.125, -178.886],
                                                    [666.63, -178.886],
                                                    [665.78, -133.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [520.275, -133.38],
                                                    [521.125, -178.886],
                                                    [878.63, -178.266],
                                                    [877.78, -132.761]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [520.275, -133.38],
                                                    [521.125, -178.886],
                                                    [878.63, -178.266],
                                                    [877.78, -132.761]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.57, "y": 1 },
                                        "o": { "x": 0.43, "y": 0 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [520.275, -133.38],
                                                    [521.125, -178.886],
                                                    [666.63, -178.886],
                                                    [665.78, -133.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 58,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [521.125, -33.38],
                                                    [521.125, -178.886],
                                                    [666.63, -178.886],
                                                    [666.63, -33.38]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
